import { RequestMethodEnum } from '@fluxonos/fluxonos-dto';

declare global {
  interface Window {
    _API_URLS_?: {
      apiServiceUrl?: string;
      [key: string]: any;
    };
    appVersion?: string;
  }
}

export interface IEnvironment {
  stage: 'development' | 'production' | 'local';
  production: boolean;
  version?: string;
  apiUrl: string;
  apiPort?: number;
  // features
  features: {
    userModule: any;
    manufacturerModule: any;
    customerModule: any;
    energySupplierModule: any;
    gridOperatorModule: any;
    [key: string]: any;
  };
}

const apiServiceUrl =
  window._API_URLS_?.apiServiceUrl && window._API_URLS_?.apiServiceUrl.length > 0
    ? window._API_URLS_?.apiServiceUrl
    : 'https://api-dev.fluxonos.com';

export const baseEnvironment = {
  stage: 'development',
  production: false,
  apiUrl: apiServiceUrl,
  features: {
    userModule: {
      user: {
        endPoint: 'user',

        /* AUTH */
        auth: {
          endPoint: 'auth',

          signIn: {
            endPoint: 'sign-in',
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          signOut: {
            endPoint: 'sign-out',
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          refreshToken: {
            endPoint: 'refresh-token',
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          }
        },

        /* USER */
        get: {
          endPoint: ``,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        addUser: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        patchUser: {
          endPoint: ``,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        patchByUserId: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },

        /* PERMISSIONS */
        permissions: {
          endPoint: `permissions`,

          list: {
            endPoint: `list`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        /* API KEYS */
        apiKey: {
          endPoint: `api-key`,

          create: {
            endPoint: ``,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          search: {
            endPoint: `search`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          deleteById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.DELETE,
            header: {
              contentType: 'application/json'
            }
          }
        }
      },

      group: {
        endPoint: 'group',

        list: {
          endPoint: `list`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        listOperatorDevice: {
          endPoint: `list/operator-device`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        }
      }
    },
    manufacturerModule: {
      endPoint: 'manufacturer',

      manufacturer: {
        endPoint: '',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        }
      },

      manufacturerModel: {
        endPoint: 'model',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },

        getByManufacturerId: {
          endPoint: (manufactureId: string) => `manufacturer-id/${manufactureId}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },

        validateMinRequirements: {
          endPoint: (id: string) => `id/${id}/min-requirements/validate`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },

        manufacturerModelModbusRegister: {
          endPoint: 'modbus-register',

          create: {
            endPoint: ``,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          patchById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          },
          getById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          deleteById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.DELETE,
            header: {
              contentType: 'application/json'
            }
          }
        }
      },
      manufacturerModelType: {
        endPoint: 'model-type',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },

        manufacturerModelTypeModbusRegisterMinReq: {
          endPoint: 'modbus-register-min-req',

          getByModelTypeId: {
            endPoint: (modelTypeId: string) => `model-type-id/${modelTypeId}`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          create: {
            endPoint: ``,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          patchById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          },
          getById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          deleteById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.DELETE,
            header: {
              contentType: 'application/json'
            }
          },
          getUsage: {
            endPoint: (id: string) => `id/${id}/usage`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          propagate: {
            endPoint: (id: string) => `id/${id}/propagate`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          }
        }
      }
    },

    customerModule: {
      endPoint: 'customer',

      customer: {
        endPoint: 'operator-device',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        searchByModel: {
          endPoint: (manufacturerModelId: string) => `search-by-model/${manufacturerModelId}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        dashboard: {
          endPoint: (id: string) => `id/${id}/dashboard`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        networkScan: {
          endPoint: (id: string) => `id/${id}/network-scan`,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        pipeline: {
          endPoint: (id: string) => `id/${id}/pipeline`,

          trigger: {
            endPoint: `trigger`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          build: {
            endPoint: 'build',

            search: {
              endPoint: `search`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            status: {
              endPoint: (buildId: string) => `id/${buildId}/status`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },
            download: {
              endPoint: (buildId: string) => `id/${buildId}/download`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },
            delete: {
              endPoint: (buildId: string) => `id/${buildId}`,
              method: RequestMethodEnum.DELETE,
              header: {
                contentType: 'application/json'
              }
            }
          }
        },

        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },
        resetAllData: {
          endPoint: (id: string) => `id/${id}/data`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },
        weatherForecast: {
          endPoint: (id: string) => `id/${id}/weather/forecast`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        weatherHistorical: {
          endPoint: (id: string) => `id/${id}/weather/historical`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        operator: {
          endPoint: (id: string) => `id/${id}/operator`,

          connected: {
            endPoint: `connected`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },

          update: {
            endPoint: `update`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          },

          latestVersion: {
            endPoint: `latest-version`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },
        terminal: {
          endPoint: (id: string) => `id/${id}/terminal`,

          createSession: {
            endPoint: `session`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          }
        },
        logs: {
          endPoint: (id: string) => `id/${id}/logs`,

          createSession: {
            endPoint: `session`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          }
        },
        metrics: {
          endPoint: (id: string) => `id/${id}/metrics`,

          history: {
            endPoint: `history`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        pvInstallation: {
          getAllByOperatorDeviceId: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/pv-installation`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          create: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/pv-installation`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          patchById: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          },
          deleteById: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}`,
            method: RequestMethodEnum.DELETE,
            header: {
              contentType: 'application/json'
            }
          },
          yieldForecast: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}/yield-forecast`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          dataRange: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}/data`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          backfillData: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}/data/backfill`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          setupStatus: {
            endPoint: (customerOperatorDeviceId: string, id: string) =>
              `${customerOperatorDeviceId}/pv-installation/id/${id}/setup-status`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        cost: {
          range: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/cost/range`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          backfill: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/cost/backfill`,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          today: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/cost/today`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        tariff: {
          prices: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/tariff/prices`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        energyBalance: {
          hourly: {
            endPoint: (customerOperatorDeviceId: string) => `${customerOperatorDeviceId}/energy-balance/hourly`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          consumptionForecast: {
            endPoint: (customerOperatorDeviceId: string) =>
              `${customerOperatorDeviceId}/energy-balance/consumption-forecast`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          }
        },

        modbus: {
          endPoint: 'modbus',

          data: {
            endPoint: `data`,

            search: {
              endPoint: `search`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            latest: {
              endPoint: `latest`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            range: {
              endPoint: `range`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            dateRange: {
              endPoint: `date-range`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            cumulatedRange: {
              endPoint: `cumulated/range`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            },

            forecastsRange: {
              endPoint: `forecasts/range`,
              method: RequestMethodEnum.GET,
              header: {
                contentType: 'application/json'
              }
            }
          }
        }
      }
    },
    energySupplierModule: {
      endPoint: 'energy-supplier',

      energySupplier: {
        endPoint: '',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        }
      },
      energyLevyRate: {
        endPoint: 'levy-rate',

        findAll: {
          endPoint: ``,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        }
      },

      energySupplierTariff: {
        endPoint: 'tariff',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        searchPriceSets: {
          endPoint: (tariffId: string) => `id/${tariffId}/price-set/search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },

        energySupplierTariffPriceSet: {
          endPoint: 'price-set',

          search: {
            endPoint: `search`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          create: {
            endPoint: ``,
            method: RequestMethodEnum.POST,
            header: {
              contentType: 'application/json'
            }
          },
          getById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.GET,
            header: {
              contentType: 'application/json'
            }
          },
          patchById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          },
          deleteById: {
            endPoint: (id: string) => `id/${id}`,
            method: RequestMethodEnum.DELETE,
            header: {
              contentType: 'application/json'
            }
          },
          activatingSetById: {
            endPoint: (id: string) => `activating-set/${id}`,
            method: RequestMethodEnum.PATCH,
            header: {
              contentType: 'application/json'
            }
          }
        }
      }
    },
    gridOperatorModule: {
      endPoint: 'grid-operator',

      gridOperator: {
        endPoint: '',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        }
      },

      gridOperatorPriceSet: {
        endPoint: 'price-set',

        search: {
          endPoint: `search`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        create: {
          endPoint: ``,
          method: RequestMethodEnum.POST,
          header: {
            contentType: 'application/json'
          }
        },
        getById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.GET,
          header: {
            contentType: 'application/json'
          }
        },
        patchById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        },
        deleteById: {
          endPoint: (id: string) => `id/${id}`,
          method: RequestMethodEnum.DELETE,
          header: {
            contentType: 'application/json'
          }
        },
        activatingSetById: {
          endPoint: (id: string) => `activating-set/${id}`,
          method: RequestMethodEnum.PATCH,
          header: {
            contentType: 'application/json'
          }
        }
      }
    }
  }
};
